<template>
  <div>
    <DxDataGrid
      :columns="itemHeaders"
      :summary="summary"
      :data-source="lineItems.items"
      :show-borders="true"
      :allow-column-resizing="true"
      :showRowLines="true"
      key-expr="id"
      @toolbar-preparing="onToolbarPreparing"
      @cell-prepared="onCellPrepared"
      :ref="itemDataGridRefKey"
      :repaint-changes-only="true"
      @row-updating="updateRow"
    >
      <template #rlt-field-show="{ data: cellData }">
        <div>
          <relate-show
            :cellData="cellData"
            :prefix="slug"
            :fieldDef="itemHeaders[cellData.columnIndex]"
          />
        </div>
      </template>
      <template #batch_dialog_field_show="{ data: cellData }">
        <div>
          <BatchDialogDetailComponent
            :modelValue="getBatchDetailRltName(cellData)"
            :cellData="cellData"
            :batchDetailfName="batchDetailfName"
            :batchModRoute="batchModRoute"
            :batchDetailModelValue="batchDetailModelValue"
          />
        </div>
      </template>
    </DxDataGrid>

    <div class="grid grid-cols-2 gap-4">
      <div class="line-add-button"></div>
      <div class="">
        <DxDataGrid
          :columns="ledgerHeaders"
          :data-source="lineItems.ledgers"
          :summary="legderSummary"
          :show-borders="true"
          :allow-column-resizing="true"
          :showRowLines="true"
          key-expr="id"
          @cell-prepared="onCellPreparedLdgr"
          :ref="ledgerDataGridRefKey"
        >
          <template #rlt-field-show="{ data: cellData }">
            <div>
              <relate-show
                :cellData="cellData"
                :prefix="slug"
                :fieldDef="ledgerHeaders[cellData.columnIndex]"
              />
            </div>
          </template>
        </DxDataGrid>
        <div class="line-add-button">
          <div class="flex">
            <div class="flex-1 ml-1">
              <DxDataGrid
                :columns="totalCol"
                :show-borders="false"
                :allow-column-resizing="true"
                :show-row-lines="false"
                :show-column-lines="false"
                :data-source="grandTotalData"
                :show-column-headers="false"
              >
                <template #bold="{ data: cellData }">
                  <span :style="{ fontWeight: 'bold' }">{{
                    cellData.value
                  }}</span>
                </template>
              </DxDataGrid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPopup,
  DxLookup,
  DxForm,
  DxHeaderFilter,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";
import DxButton from "devextreme-vue/button";
import Guid from "devextreme/core/guid";
import DxDateBox from "devextreme-vue/date-box";
import CustomFieldTypes from "./CustomFieldTypes.vue";
import RelateShow from "./line_item/ListRelateFieldShow.vue";
import BatchDialogDetailComponent from "@/components/BatchDialogDetailComponent.vue";

import {
  getInvoiceItemLayoutDef,
  getInvoiceFieldDef,
} from "../Pages/Builder/base.js";

const itemDataGridRefKey = "itemDataGrid";
const ledgerDataGridRefKey = "ledgerDataGrid";
let sTotal = 0;

export default {
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    def: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    slug: String,
    defaultData: {
      type: Array,
      default: [],
    },
    fname: String,
    modRoute: String,
  },
  components: {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxButton,
    DxDateBox,
    CustomFieldTypes,
    RelateShow,
    BatchDialogDetailComponent,
  },
  data() {
    return {
      dateValue: new Date(),
      apple: new Date(),
      itemDataGridRefKey,
      ledgerDataGridRefKey,
      sTotal,
      lineItems: { items: [], ledgers: [] },
      itemHeaders: [],
      ledgerHeaders: [],
      LineCount: 2,
      dataSource: [
        /* {
                        ID: 1,
                        Item: '',
                        Quantity: '',
                        Rate: '',
                        Discount: '',
                        Tax:'',
                        Amount:0,
                    } */
      ],
      count: 1,
      showBorders: true,
      showRowLines: true,
      newRowPosition: "last",
      changes: [],
      editRowKey: null,
      summary: {
        recalculateWhileEditing: true,
        totalItems: [
          {
            column: "Amount",
            summaryType: "sum",
            displayFormat: "Total: {0}",
          },
        ],
      },
      legderSummary: {
        recalculateWhileEditing: true,
        totalItems: [
          {
            column: "Amount",
            summaryType: "sum",
            displayFormat: "Total: {0}",
            showInColumnFooter: false,
          },
        ],
      },
      legderSummary1: {
        recalculateWhileEditing: true,
        totalItems: [
          {
            name: "SelectedRowsSummary",
            showInColumn: "Amount",
            showSummary: "false",
            summaryType: "custom",
            displayFormat: "Grand Total: {0}",
          },
        ],
        calculateCustomSummary(options) {
          if (options.name === "SelectedRowsSummary") {
            if (options.summaryProcess === "start") {
              options.totalValue = sTotal;
            }
            //console.log(options.summaryProcess);
            if (options.summaryProcess === "calculate") {
              //if (options.component.isRowSelected(options.value.ID)) {
              options.totalValue += options.value.Amount;
              //}
            }
          }
        },
      },
      totalCol: [
        {
          dataField: "GrandTotal",
          cellTemplate: "bold",
          alignment: "right",
        },
        {
          dataField: "value",
          width: 100,
          cellTemplate: "bold",
        },
        {
          type: "empty",
          width: 40,
        },
      ],
      columns: [
        {
          dataField: "Item",
          caption: "Item Details",
        },
        "Quantity",
        "Rate",
        {
          dataField: "Discount",
          width: 170,
        },
        {
          dataField: "Tax",
          caption: "Tax",
          width: 125,
          lookup: {
            dataSource: [],
            displayExpr: "Name",
            valueExpr: "ID",
          },
        },
        {
          dataField: "Amount",
          alignment: "right",
          width: 100,
        },
      ],
      ledgerColumns: [
        {
          dataField: "Ledger",
          caption: "Ledger",
        },
        {
          dataField: "Amount",
          caption: "Amount",
          width: 100,
        },
      ],
      ledgerData: [
        /* {
                        ID: 1,
                        Ledger: 'GST',
                        Amount: 890
                    } */
      ],
      grandTotalData: [
        {
          GrandTotal: "Grand Total:",
          value: 0,
        },
      ],
      batchDetailfName:null,
      batchModRoute:null,
      batchDetailModelValue:null,
    };
  },
  methods: {
    updateRow(e) {
      //A function that is executed before a row is updated in the data source.
      //console.log("tar",e);
    },
    onToolbarPreparing: function (e) {
      var toolbarItems = e.toolbarOptions.items;
      $.each(toolbarItems, function (_, item) {
        if (item.name == "saveButton" || item.name == "revertButton") {
          item.visible = false;
        }
      });
    },
    addNewRow() {
      this.itemDataGrid.addRow();
    },
    addLedgerRow() {
      this.ledgerDataGrid.addRow();
    },
    getGrandTotal(options) {
      if (options.name === "SelectedRowsSummary") {
        if (options.summaryProcess === "start") {
          options.totalValue = 0;
        }
        if (options.summaryProcess === "calculate") {
          if (options.component.isRowSelected(options.value.ID)) {
            options.totalValue += options.value.SaleAmount;
          }
        }
      }
    },
    save() {
      this.itemDataGrid.saveEditData();
      console.log("formData", this.dataSource);
      //add listner
      //https://js.devexpress.com/Documentation/ApiReference/UI_Components/dxDataGrid/Configuration/#onCellPrepared
    },
    overrideOnValueChanged(e) {
      //this will call when any cell in focus
      //console.log('Focus moved out of the DataGrid',e);
      if (e.dataField === "Discount" && e.parentType === "dataRow") {
        const defaultValueChangeHandler = e.editorOptions.onValueChanged;
        //console.log("gfd",defaultValueChangeHandler);
        //e.editorOptions.onValueChanged = function (args) {
        //}
      }
      //calculation for amount
      //console.log("tar",e.value);
    },
    onCellPrepared(e) {
      if (
        e.rowType === "data" &&
        (e.column.dataField === "Amount" ||
          e.column.dataField === "Quantity" ||
          e.column.dataField === "Rate")
      ) {
        /* console.log(e);
                console.log("tar1",(e.data.Quantity * e.data.Rate));
                console.log("tar",e.data.Amount); */

        /* this.itemDataGrid.saveEditData();            
                console.log("formData",this.dataSource); */
        //check if amount not null then only set
        let val = e.data.Quantity * e.data.Rate;
        if (val != null && val != 0) {
          e.data.Amount = e.data.Quantity * e.data.Rate;
        }

        if (e.rowIndex == 0) {
          //this.dataSource[0].Amount = e.data.Quantity * e.data.Rate;
        }
      }
      sTotal = this.itemDataGrid.getTotalSummaryValue("Amount");
      sTotal += this.ledgerDataGrid.getTotalSummaryValue("Amount");

      this.grandTotalData[0].value = sTotal;

      //this.ledgerDataGrid.refresh("Amount");
    },
    onCellPreparedLdgr(e) {
      if (e.rowType === "data" && e.column.dataField === "Amount") {
        //sTotal += e.data.Amount;
        //console.log("tar",e.data.Amount);
      }
      sTotal = this.itemDataGrid.getTotalSummaryValue("Amount");
      sTotal += this.ledgerDataGrid.getTotalSummaryValue("Amount");

      this.grandTotalData[0].value = sTotal;

      //this.ledgerDataGrid.refresh("Amount");
    },
    getFormDef(fname) {
      getInvoiceFieldDef(this.modRoute, fname, false).then((response) => {
        this.itemHeaders = Object.values(response.data.top);
        this.ledgerHeaders = Object.values(response.data.bottom);
        //this.items.push(this.btnLayout);
        /*
                    this.LineCount = this.items2[0].items[0].items.length;
                    ///console.log(this.items2[0].items[0].items.length);
                    //set blank first row
                    if(this.lineItems.items.length < 1) {                
                        this.lineItems.items[0]= this.getNewObj();                        
                    }
                    
                    if(this.lineItems.ledgers.length < 1) {                
                        this.lineItems.ledgers[0]= this.getBottomObj();                        
                    } */
      });
    },
    getBatchDetailRltName(cellData) {
      if (this.modRoute.startsWith("cnsl")) {
        this.batchDetailfName = "CnslBatchDetail_LineItem";
        this.batchModRoute = "cnsl-batch-detail";
        
        return cellData.rlt_cnslinventorydetail_cnslbatchdetail; // Set the appropriate value based on your condition
      }
      else{
        this.batchDetailfName = "BatchDetail_LineItem";
        this.batchModRoute = "batch-detail";
      }
      return cellData.rlt_inventorydetail_batchdetail; // Or some default value
    },
  },
  mounted() {
    this.lineItems = this.modelValue;
    this.$watch("sTotal", (nval, oval) => {
      //onsole.log("gts");
    });
    console.log("ds modRoute", this.modRoute);
    //this.getFormDef(this.fname);
    //check for null

    this.itemHeaders = this.def.editorOptions.top_view;
    this.ledgerHeaders = this.def.editorOptions.bottom_view;

    //console.log("sds",this.itemDataGrid.getTotalSummaryValue('Amount'));
    this.itemDataGrid.columnOption("command:edit", "width", 40);
    this.ledgerDataGrid.columnOption("command:edit", "width", 40);

    console.log("InvoiceFieldDetailComponent Header ", this.itemHeaders);
    console.log("InvoiceFieldDetailComponent DATA ", this.lineItems);
  },
  computed: {
    itemDataGrid: function () {
      return this.$refs[itemDataGridRefKey].instance;
    },
    ledgerDataGrid: function () {
      return this.$refs[ledgerDataGridRefKey].instance;
    },
    batchDetailValue() {
      if (this.modRoute.startsWith("cnsl")) {
        return this.someValue; // Set the appropriate value based on your condition
      }
      return null; // Or some default value
    },
  },
};
</script>

<style>
</style>